import { Industry, ApplicationFormContent } from 'src/types';

import personOnlineBankingIllustration from 'src/assets/images/illustrations/finance/person-online-banking-illustration.png';
import financeApplicationFormStyles from 'src/styles/finance/applicationForm.module.css';

import travelInsuranceCoverageIllustration from 'src/assets/images/illustrations/insurance/travel-insurance-coverage-illustration.png';
import insuranceApplicationFormStyles from 'src/styles/insurance/applicationForm.module.css';

import rouletteWheelIllustration from 'src/assets/images/illustrations/gambling/roulette-wheel-illustration.png';
import gamblingApplicationFormStyles from 'src/styles/gambling/applicationForm.module.css';

import mobileIllustration from 'src/assets/images/illustrations/mobile/mobile-illustration.png';
import mobileApplicationFormStyles from 'src/styles/mobile/applicationForm.module.css';

import abstractFashionModelIllustration from 'src/assets/images/illustrations/retail/abstract-fashion-model-illustration.png';
import retailApplicationFormStyles from 'src/styles/retail/applicationForm.module.css';

export const APPLICATION_FORM_CONTENT_MAP: Record<
  Industry,
  ApplicationFormContent
> = {
  Finance: {
    cssStyles: financeApplicationFormStyles,
    introSection: {
      header: 'Apply for Credit Card',
      body: "Enjoy exclusive benefits, rewards, and financial flexibility with our range of credit cards tailored to your needs. Whether you're looking for cashback, travel perks, or low interest rates, we have the perfect card for you.",
    },
    image: {
      src: personOnlineBankingIllustration,
      alt: 'Person online banking illustration',
    },
  },
  Insurance: {
    cssStyles: insuranceApplicationFormStyles,
    introSection: {
      header: 'Sign up for Travel insurance',
      body: "Wherever your journey takes you, make sure you're protected with our comprehensive travel insurance. From unexpected cancellations to medical emergencies, we've got you covered so you can explore with peace of mind.",
    },
    image: {
      src: travelInsuranceCoverageIllustration,
      alt: 'Travel insurance coverage illustration',
    },
  },
  Gambling: {
    cssStyles: gamblingApplicationFormStyles,
    introSection: {
      header: 'Open your Spinzalot account',
      body: 'Spin the reels, test your skills at the tables, and enjoy a secure, fair, and immersive gaming experience. Ready to play? Sign up now and let the fun begin!',
    },
    image: {
      src: rouletteWheelIllustration,
      alt: 'Roulette wheel illustration',
    },
  },
  Mobile: {
    cssStyles: mobileApplicationFormStyles,
    introSection: {
      header: 'Join NostraTel today',
      body: 'Join our network and enjoy fast, reliable coverage, great deals, and unbeatable customer support. Whether you need unlimited data, affordable international calls, or the latest smartphones, we’ve got a plan for you.',
    },
    image: {
      src: mobileIllustration,
      alt: 'Mobile illustration',
    },
  },
  Retail: {
    cssStyles: retailApplicationFormStyles,
    introSection: {
      header: 'Create your Membership account',
      body: 'Enjoy early access to new collections, members-only discounts, and personalized style recommendations. From timeless essentials to trend-setting pieces, your wardrobe upgrade starts here. Sign up now and make every outfit unforgettable!',
    },
    image: {
      src: abstractFashionModelIllustration,
      alt: 'Abstract fasion model illustration',
    },
  },
};
